import StakingHistoryChart from './StakingHistoryChart'
import StakingAnalysisOverview from './StakingAnalysisOverview'

const StakingAnalysis = ({ onBack }) => {

    return (
        <div className={'flex flex-col gap-5 w-full'}>
            <StakingAnalysisOverview />
            <StakingHistoryChart />
        </div>
    )
}

export default StakingAnalysis
